<template>
  <div id="push-handler"/>
</template>

<script>
import {storeFcmToken} from "boot/axios";

export default {
  name: "PushHandler",
  async mounted() {
    try {
      // eslint-disable-next-line no-undef
      FCM.requestPushPermission();

      let token = await FCM.getToken()
      storeFcmToken(token)

      // eslint-disable-next-line no-undef
      FCM.onTokenRefresh(function(token){
        storeFcmToken(token)
      });

      let notified = []

      // eslint-disable-next-line no-undef
      FCM.onNotification((data) => {
        if (data.meta && data.meta.plugin === 'cordova-plugin-local-notification') {
          return;
        }

        if(data['gcm.message_id']){
          if(notified.indexOf(data['gcm.message_id']) > -1){
            return
          }

          notified.push(data['gcm.message_id'])
        }

        notified.push(data['gcm.message_id'])

        let text = data.body

        cordova.plugins.notification.local.schedule({
          title: data.title,
          text: text,
          foreground: true
        });
      });
    } catch {

    }
  }
}
</script>

<style scoped>

</style>
